import Grid from "@mui/material/Grid";
import SideNavBar from "../SideNavBar/SideNavBar";
import MainArea from "../MainArea/MainArea";
import {
	mainContents,
	resource,
} from "../../utility/constants/resource/resource";
import { useState, useCallback } from "react";
import { sidebarOptions } from "../../utility/constants/resource/resource";

const MainGrid = () => {
	const [currentMainArea, setCurrentMainArea] = useState<any>(
		mainContents[0]
	);
	const [showLeftArrow, setShowLeftArrow] = useState<boolean>(false);
	const [showRightArrow, setShowRightArrow] = useState<boolean>(
		mainContents?.length > 0
	);
	const [options, setOptions] = useState<any>(sidebarOptions);
	const onClickSidebar = useCallback((name: string) => {
		const index = mainContents.findIndex((i) => i.name === name);
		let leftArrow = false;
		let rightArrow = false;
		if (index >= 0) {
			setCurrentMainArea(mainContents[index]);
			if (index === 0) {
				leftArrow = false;
				rightArrow = true;
			} else if (index === mainContents.length - 1) {
				leftArrow = true;
				rightArrow = false;
			} else if (index > 0 && index < mainContents.length - 1) {
				leftArrow = true;
				rightArrow = true;
			}
		}
		const updatedOptions = options?.map((obj: any) => {
			let item = obj;
			item.isActive = false;
			item.style.color = resource.colors.defaultColor;
			if (item.name === name) {
				item.isActive = true;
				item.style.color = resource.colors.activeColor;
			}
			return item;
		});
		setOptions?.(updatedOptions);
		setShowLeftArrow(leftArrow);
		setShowRightArrow(rightArrow);
	}, []);
	const onClickArrowMainArea = useCallback(
		(direction: string) => {
			const currIndex = mainContents.findIndex(
				(i) => i.name === currentMainArea.name
			);
			switch (direction) {
				case "left":
					if (currIndex >= 1) {
						onClickSidebar(mainContents[currIndex - 1].name);
					}
					break;
				case "right":
					if (currIndex < mainContents.length - 1) {
						onClickSidebar(mainContents[currIndex + 1].name);
					}
					break;
				default:
					break;
			}
		},
		[currentMainArea, onClickSidebar]
	);
	return (
		<Grid container spacing={0.5} sx={{ height: "100%" }}>
			<Grid item xs={1}>
				<SideNavBar
					options={options}
					setOptions={setOptions}
					onClick={onClickSidebar}
				/>
			</Grid>
			<Grid item xs={11}>
				<MainArea
					showLeftArrow={showLeftArrow}
					showRightArrow={showRightArrow}
					onClickArrow={onClickArrowMainArea}
					currentMainArea={currentMainArea}
				/>
			</Grid>
		</Grid>
	);
};
export default MainGrid;
